import { useGLTF } from '@react-three/drei'
import { GLTF } from 'three-stdlib'


type GLTFResult = GLTF & {
  nodes: {}
  materials: {}
}

export function GroupHead() {
    const { nodes, materials, animations } = useGLTF('objects/group-head.gltf') as GLTFResult
    return animations
}

useGLTF.preload('objects/group-head.gltf')